var skillsData = {
    section_back:"Back End Skills",
    section_front:"Front End skills",
}

exports.skillsData = skillsData